function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110,42.7L110,42.7l0.8-2.4l0,0l0,0L55.4,0L0,40.2l0,0c0,0,0,0,0,0l0.3,0.9l20.9,67h17.4h5.2h9H58h9h5.2h17.4L110,42.7z  M98.6,37.9H12.1L55.4,6.4L98.6,37.9z M25,103L6.2,42.7h32.4V103H25z M43.8,103V42.7h9V103H43.8z M58,103V42.7h9V103H58z M72.1,103 V42.7h32.4L85.7,103H72.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.6,24h-49.9c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h22.4v62.9c0,1.4,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6V28.8 h22.4c1.3,0,2.4-1.1,2.4-2.4S186.9,24,185.6,24z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.3,64c11.8-1.6,20.5-8.3,20.5-20v-0.2c0-5-2-9.7-5.3-13c-4.2-4.2-11.1-6.9-19.7-6.9H206c-1.4,0-2.6,1.2-2.6,2.6v65.1 c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6V64.9h22.9l21.5,28c0.6,0.8,1.3,1.4,2.3,1.4c1.4,0,2.7-1.3,2.7-2.7c0-0.6-0.3-1.2-0.8-1.8 L237.3,64z M208.6,60.2V28.8h23.9c12.7,0,20.1,5.9,20.1,15.3v0.2c0,10.1-8.7,16-20.4,16H208.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278.9,23.6c-1.4,0-2.6,1.2-2.6,2.6v65.5c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6V26.2C281.5,24.8,280.3,23.6,278.9,23.6z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.5,23.6c-1.2,0-2.1,0.9-2.6,2l-26.8,62.7l-26.7-62.6c-0.5-1.2-1.4-2.1-2.7-2.1c-1.5,0-2.6,1.3-2.6,2.5 c0,0.5,0,0.7,0.2,1.1l28.5,65.1c0.6,1.4,1.5,2.3,3.1,2.3h0.2c1.6,0,2.5-0.9,3.1-2.3L361.8,27c0.2-0.4,0.2-0.6,0.2-1 C362,24.8,360.9,23.6,359.5,23.6z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M426.1,89.1h-43V61h38c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4h-38V28.8h42.5c1.3,0,2.4-1.1,2.4-2.4 s-1.1-2.4-2.4-2.4h-45.1c-1.4,0-2.6,1.2-2.6,2.6v64.7c0,1.4,1.2,2.6,2.6,2.6h45.6c1.3,0,2.4-1.1,2.4-2.4 C428.5,90.2,427.4,89.1,426.1,89.1z"
});

var SvgLogoPlain = function SvgLogoPlain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 428.5 108.2",
    style: {
      enableBackground: "new 0 0 428.5 108.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo--plain.899cac7d.svg";
export { ForwardRef as ReactComponent };